import { useState } from "react";
import { DataTable } from "../components/DataTable";
import { useAuth } from "../context/AuthContext";
import { initialCustomers } from "../data/customers";
import type { Customer } from "../data/types";

export function CustomersPage() {
  const { user } = useAuth();
  const [customers, setCustomers] = useState<Customer[]>(initialCustomers);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const canManage = user?.role === "admin";

  function addCustomer() {
    if (!name || !email || !canManage) return;
    setCustomers((prev) => [
      { id: `c_${Date.now().toString(36)}`, name, email, orders: 0, spent: 0 },
      ...prev,
    ]);
    setName("");
    setEmail("");
  }

  function deleteCustomer(id: string) {
    if (!canManage) return;
    setCustomers((prev) => prev.filter((item) => item.id !== id));
  }

  return (
    <div className="d-grid gap-3">
      {canManage ? (
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-5">
                <input
                  className="form-control"
                  placeholder="Customer name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-md-5">
                <input
                  className="form-control"
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <button type="button" className="btn btn-primary w-100" onClick={addCustomer}>
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <DataTable
        title="Customers"
        rows={customers}
        columns={[
          { key: "name", label: "Name", sortable: true },
          { key: "email", label: "Email", sortable: true },
          { key: "orders", label: "Orders", sortable: true },
          { key: "spent", label: "Total Spent", sortable: true, render: (row) => `Rs ${row.spent.toLocaleString()}` },
          canManage
            ? {
                key: "actions",
                label: "Actions",
                className: "text-end",
                render: (row) => (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteCustomer(row.id)}
                  >
                    Delete
                  </button>
                ),
              }
            : { key: "placeholder", label: "", render: () => null },
        ]}
        rowKey={(row) => row.id}
        searchPlaceholder="Search customers..." exportFileName="customers"
        onDeleteRow={(id) => deleteCustomer(id)}
        deleteItemLabel="Customer"
      />
    </div>
  );
}
